import type { WordCollection } from "../collection.types";

export const winterSolsticeCollection: WordCollection = {
  id: "winter-solstice",
  title: "Winter Solstice (Yule)",
  icon: "weather-night",
  isWordlistViewable: true,
  startDate: new Date(new Date().getFullYear(), 11, 18), // December 18th
  endDate: new Date(new Date().getFullYear(), 11, 23), // December 23rd
  words: [
    "ash",
    "bitter",
    "bond",
    "branch",
    "cedar",
    "ceremony",
    "cold",
    "comfort",
    "community",
    "dawn",
    "depth",
    "evergreen",
    "family",
    "flame",
    "frost",
    "glow",
    "harsh",
    "ice",
    "love",
    "mystery",
    "needle",
    "night",
    "oak",
    "origin",
    "pine",
    "promise",
    "quiet",
    "restoration",
    "return",
    "secret",
    "security",
    "shadow",
    "spark",
    "star",
    "start",
    "unity",
  ],
};
